export function sendPostRequest(url, data, callback) {
  fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json", // Set the appropriate content type
    },
    body: JSON.stringify(data), // Convert your data to a JSON string
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((responseData) => {
      // Handle the response data
      callback(null, responseData);
    })
    .catch((error) => {
      // Handle any errors
      callback(error, null);
    });
}
